module.exports = __webpack_public_path__ + "img/image (69).4714ef38.jpg";